import { Component,ViewChild, AfterViewInit, OnDestroy, NgZone } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';

import { IconDirective } from '@coreui/icons-angular';
import {
  ContainerComponent,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective,
  ToasterComponent,
  ToasterPlacement
} from '@coreui/angular-pro';

import { DefaultAsideComponent, DefaultFooterComponent, DefaultHeaderComponent } from './';
import { getNavItems } from './_nav';
import { ToastService } from '../../toast.service';
import { AppToastComponent } from '../../views/notifications/toasters/toast-simple/toast.component';
import { Subject, takeUntil } from 'rxjs';
import { AdminSettingsService } from '../../views/cruds/admin-settings/admin-settings.service';


function isOverflown(element: HTMLElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,
    IconDirective,
    NgScrollbar,
    SidebarNavComponent,
    SidebarFooterComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    DefaultAsideComponent,
    DefaultHeaderComponent,
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    DefaultFooterComponent,
    ToasterComponent,

  ]
})
export class DefaultLayoutComponent {
  
   navItems:any = []
    placement = ToasterPlacement.TopEnd;

  @ViewChild(ToasterComponent, { static: true }) toaster!: ToasterComponent;

  private destroy$ = new Subject<void>();

  constructor(
    private toastService: ToastService,
    private zone: NgZone,
    private adminSettings: AdminSettingsService
  ) {}

  ngOnInit() {
    this.navItems = getNavItems();
    const userInfo = this.readUserInfo();
    const effectiveRoleId = Number(userInfo.effectiveRoleId || userInfo.role_id || 0);
    const permissionsRequest = effectiveRoleId
      ? this.adminSettings.getMyRolePermissions(effectiveRoleId)
      : this.adminSettings.getMyPermissions();

    permissionsRequest
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          localStorage.setItem('UserPermissions', JSON.stringify(res?.data || []));
          this.navItems = getNavItems();
        },
        error: () => {
          localStorage.removeItem('UserPermissions');
          this.navItems = getNavItems();
        }
      });

    // Subscribe EARLY so no emits are missed
    this.toastService.toastState
      .pipe(takeUntil(this.destroy$))
      .subscribe(options => {
        // ensure we're in Angular zone for change detection
        this.zone.run(() => this.toaster.addToast(AppToastComponent, options));
      });
  }

  private readUserInfo(): any {
    try {
      return JSON.parse(localStorage.getItem('UserInfo') || '{}');
    } catch {
      return {};
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onScrollbarUpdate($event: any) {
    // if ($event.verticalUsed) {
    // console.log('verticalUsed', $event.verticalUsed);
    // }
  }
}
